import { BODY_TYPE_FILTER_CATEGORY } from '../../../core/reducers/vehicleListFilters';
const getModelCardsFromFilteredModels = (modelCardsByVehicleType, vehicles, selectedFilterItems = []) => {
    if (!modelCardsByVehicleType || !vehicles)
        return {};
    const vehicleTrimKeys = new Set(vehicles.map(vehicle => vehicle.trimKey));
    const selectedBodyTypes = selectedFilterItems.filter(item => item.startsWith(BODY_TYPE_FILTER_CATEGORY));
    const selectedBodyTypeValues = selectedBodyTypes.map(value => value === null || value === void 0 ? void 0 : value.split('|')[1]);
    const result = Object.entries(modelCardsByVehicleType).reduce((acc, [key, modelCards]) => {
        const filteredArray = modelCards.filter(card => vehicleTrimKeys.has(card.trimKey));
        if (filteredArray.length > 0) {
            acc[key] = filteredArray;
        }
        return acc;
    }, {});
    // if the user has selected only one body type, delete all others body types and their cards
    if (selectedBodyTypeValues.length === 1) {
        Object.keys(result).forEach(key => {
            if (selectedBodyTypeValues[0] && selectedBodyTypeValues[0] !== key) {
                delete result[key];
            }
        });
    }
    return result;
};
export default getModelCardsFromFilteredModels;
